export const agencyProfilesRoutes = [
  {
    path: '/partners',
    name: 'Partners',
    component: () =>
      import(
        /* webpackChunkName: "partners" */ '@/views/Dashboard/AgencyProfiles/Partners.vue'
      ),
  },
  {
    path: '/partners/:id',
    name: 'PartnerDetail',
    component: () =>
      import(
        /* webpackChunkName: "partnersDetail" */ '@/views/Dashboard/AgencyProfiles/PartnerDetail.vue'
      ),
  },
  {
    path: '/partners/invitations/:id',
    name: 'PartnerInvitation',
    component: () =>
      import(
        /* webpackChunkName: "partnerInvitation" */ '@/views/Dashboard/AgencyProfiles/PartnerInvitation.vue'
      ),
  },
  {
    path: '/invite/agency',
    name: 'InviteAgency',
    component: () =>
      import(
        /* webpackChunkName: "inviteAgency" */ '@/views/Dashboard/AgencyProfiles/InviteAgency.vue'
      ),
  },
];
